// ag-grid valueFormatter for money columns: comma separated with exactly 2 decimals (e.g. 123456.7 -> 123,456.70).
// Display only - the underlying value stays numeric, so sorting and Excel export are unaffected.
export const amountFormatter = (params: any): string => {
  if (params.value === null || params.value === undefined || params.value === "") {
    return "";
  }
  const value = Number(params.value);
  if (isNaN(value)) {
    return params.value;
  }
  return value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

// Same, rounded to whole rupees (balances and totals): 123456.7 -> 123,457
export const wholeAmountFormatter = (params: any): string => {
  if (params.value === null || params.value === undefined || params.value === "") {
    return "";
  }
  const value = Number(params.value);
  if (isNaN(value)) {
    return params.value;
  }
  return value.toLocaleString("en-US", { maximumFractionDigits: 0 });
};



// WEBPACK FOOTER //
// ./src/app/custompipes/amount-formatter.ts